import { useEffect, useState } from "react";
import { ProjectServiceList } from "@/components/specific/projectservices/ProjectServiceList";
import { getProjectServices } from "../../api/projectServicesMaintenance/api";
import { ProjectService } from "../../types/domain";
import { MaintenanceSection, MaintenanceSectionContent, MaintenanceSectionHeader } from "../../components/layout/maintenance";
import { CreateEditProjectServiceDialog } from "@/components/specific/projectservices/CreateEditProjectServiceDialog";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export const ProjectServicesMaintenancePage = () => {
  const [services, setServices] = useState<ProjectService[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchServices = async () => {
    try {
      setIsLoading(true);
      setServices(await getProjectServices());
    } catch (err) {
      console.error("Error fetching services: ", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  return (
    <>
      <MaintenanceSection>
        <MaintenanceSectionHeader title="Project Services">
          <CreateEditProjectServiceDialog
            services={services}
            callBack={fetchServices}
            triggerVariant={"outline"}
            triggerText="Create Service"
            triggerIcon={faPlus}
          />
        </MaintenanceSectionHeader>
        <MaintenanceSectionContent>
          <ProjectServiceList services={services} fetchServices={fetchServices} isLoading={isLoading} />
        </MaintenanceSectionContent>
      </MaintenanceSection>
    </>
  );
};
